"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthElement = void 0;
/**
 * This entity is a root level object. It represents a healthcare element. It is serialized in JSON and saved in the underlying CouchDB database.
 */
class HealthElement {
    constructor(json) {
        Object.assign(this, json);
    }
}
exports.HealthElement = HealthElement;
(function (HealthElement) {
    HealthElement.LateralityEnum = {
        Left: 'left',
        Right: 'right',
    };
})(HealthElement = exports.HealthElement || (exports.HealthElement = {}));
//# sourceMappingURL=HealthElement.js.map